import { PropsWithChildren } from 'react';
import { useDisclosure } from '../../../lib/hooks';
import { TaskDetailPanelContext } from './context';
import TaskDetailPanel from './TaskDetailPanel';
import { CredentialTaskDto } from '../../../api/app.types';

const TaskDetailPanelProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const panel = useDisclosure<CredentialTaskDto>();

  return (
    <TaskDetailPanelContext value={panel}>
      {<TaskDetailPanel task={panel?.value} close={panel.close} />}
      {children}
    </TaskDetailPanelContext>
  );
};

export default TaskDetailPanelProvider;
